export enum Disposition {
    Burial = 'Burial',
    Cremation = 'Cremation',
}
